import { SAL2080_R01Dto } from "./Dto_SAL2080_R01";
import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { SAL2080_R01Filter } from "./Store_SAL2080_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/SAL2080_R01`;

const getParams = (filter: Partial<SAL2080_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd || undefined,
		customCd: filter.customCd || undefined,
		taxType: filter.taxType || undefined,
		taxBilling: filter.taxBilling || undefined,
		startDate: filter.issuedDateRange?.from ? formatDate(filter.issuedDateRange.from) : undefined,
		endDate: filter.issuedDateRange?.to ? formatDate(filter.issuedDateRange.to) : undefined,
		remark: filter.remark || undefined,
		listLength: listLength || 0
	}
}

// 세금계산서 리스트 조회
export const getSAL2080_R01List = async (option: string, params: Partial<SAL2080_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<SAL2080_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

// 엑셀 다운로드 (Base64 문자열 응답)
export const downloadExcel_SAL2080_R01 = async (option: string, params: Partial<SAL2080_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;
	const requestParams = getParams(params, undefined);
	return await getData<ResponseDto<string>>(url, { params: { ...requestParams, listLength } });
}

/** 세금계산서 PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_SAL2080_R01 = async (taxBillNo: string, mode: 'AGG' | 'EXPAND' = 'AGG'): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { taxBillNo, mode },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};

